import { render } from "./NumberManagement.vue?vue&type=template&id=fd4d3f6a&scoped=true"
import script from "./NumberManagement.vue?vue&type=script&lang=js"
export * from "./NumberManagement.vue?vue&type=script&lang=js"

import "./NumberManagement.vue?vue&type=style&index=0&id=fd4d3f6a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4d3f6a"]])

export default __exports__